
import { defineComponent } from 'vue'
import store from '@/store/index'
export default defineComponent({
    props: ['dataTitle', 'list', 'width', 'isCloseType'],
    data() {
        return {
            includeList: [] as string[],
            $store: store
        }
    },
    watch: {
        async $route(to: { meta: { keepAlive: boolean }, path: string, name: string, query?: Record<string, any> }) {
            // $store.state.tagsPages.map(item=>item.name)
            const queryList = store.state.tagsPages.filter(item => Object.keys(item?.query ?? {}).length)
            if (to.meta.keepAlive !== false && ((this.includeList = store.state.tagsPages.map(item => item.name)).indexOf(to.name) === -1)) {
                if (store.state.tagsPages.some((item: { path: string, query?: Record<string, any> }) => item.path === to.path && (item?.query && JSON.stringify(item.query) === JSON.stringify(to.query))) && (to.meta.keepAlive === true || to.meta.keepAlive !== false)) { return }
                store.commit('addPage', this.$route)
            }
            if (this.isDiffentQuery(queryList, to)) {
                store.commit('replacePage', this.$route)
            }
        }
    },
    methods: {
        isDiffentQuery(queryList: any, to: any) {
            const sameName = queryList.find(item => item.name === to.name)
            if (!sameName && (!Object.keys(sameName?.query ?? {}).length || !Object.keys(to?.query ?? {}).length)) return false
            return JSON.stringify(sameName.query) !== JSON.stringify(to.query)
        },
        close() {
            this.$emit('close')
        },
        delTab(page: string, name: string) {
            console.log(page, name, '1234556')
            store.commit('delPage', { page, name })
        },
        goTabPage(item: any) {
            console.log(121, item);
            this.$router.push({
                path: item.path,
                query: item.query
            })
        },
        onTabClick(pane: any) {
            const name = (pane && (pane.paneName ?? pane.props?.name ?? pane.name)) || this.$route.name
            const item = store.state.tagsPages.find((i: any) => i.name === name)
            if (item) this.goTabPage(item)
        }
    }
})
